import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityMaterialApi, FindEntityMaterialForInheritQuery } from 'api';

export const filterEntityMaterial = createAsyncThunk(
  'entityMaterial/filterEntityMaterial',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityMaterialApi.filter(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

// Chỉ sử dụng cho table list danh sách vật tư
export const findEntityMaterialWithEntity = createAsyncThunk(
  'entityMaterial/findEntityMaterialWithEntity',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityMaterialApi.findWithEntity(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityMaterial = createAsyncThunk(
  'entityMaterial/createEntityMaterial',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityMaterialApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityMaterial = createAsyncThunk(
  'entityMaterial/findOneEntityMaterial',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id } = params;
      const response = await EntityMaterialApi.findOne(id);
      // const response = await EntityMaterialApi.findOne(params);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findInheritEntityMaterial = createAsyncThunk(
  'entityMaterial/findInheritEntityMaterial',
  async (params: FindEntityMaterialForInheritQuery, { rejectWithValue }) => {
    try {
      const response = await EntityMaterialApi.findInheritEntityMaterial(
        params
      );

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityMaterial = createAsyncThunk(
  'entityMaterial/updateEntityMaterial',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityMaterialApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityMaterialStatus = createAsyncThunk(
  'entityMaterial/updateEntityMaterialStatus',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityMaterialApi.updateStatus(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteEntityMaterial = createAsyncThunk(
  'entityMaterial/deleteEntityMaterial',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityMaterialApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface EntityMaterialState {
  tableList: Array<any>;
  isLoaded: boolean;
  savedList: Array<any>;
  reloadFlag: boolean;
  savedPagination: any;
}

const initialState: EntityMaterialState = {
  tableList: [],
  isLoaded: false,
  savedList: [],
  reloadFlag: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
};

const entityMaterialSlice = createSlice({
  name: 'entityMaterial',
  initialState,
  reducers: {
    reloadEntityMaterial(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEntityMaterial(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEntityMaterial(state, action) {
      state.savedList = action.payload;
    },
  },
});

const { actions, reducer: entityMaterialReducer } = entityMaterialSlice;

export const {
  reloadEntityMaterial,
  updateSavedPaginationEntityMaterial,
  updateSavedListEntityMaterial,
} = actions;

export default entityMaterialReducer;
